import { render } from "./PatientProfile.vue?vue&type=template&id=4fca1ff5&scoped=true&ts=true"
import script from "./PatientProfile.vue?vue&type=script&lang=ts"
export * from "./PatientProfile.vue?vue&type=script&lang=ts"

import "./PatientProfile.vue?vue&type=style&index=0&id=4fca1ff5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fca1ff5"]])

export default __exports__